const TeamAccess = {
  MY_TEAM: 'MY_TEAM',
  ALL_TEAMS: 'ALL_TEAMS',
} as const

type TeamAccess = (typeof TeamAccess)[keyof typeof TeamAccess]

export { TeamAccess }
